import "./ownSales.css";
import { useMemo, useState } from "react";
import { DateRangeProps, OperationArea, OperationItem } from "../area";
import { useDashboardSummary, useLanguage } from "../../../hooks";
import { OperationStatistics } from "../graphics";
import { vars } from "../../../assets";
import { RouterEnum } from "../../../router";
import { ReportsTabEnum } from "../../../screens";
import { getCurrentMonthToTodayRange, toChartRows } from "../../../utils";

const formatCurrency = (value: number): string => `${value.toLocaleString("es-ES")}€`;

const OperationOwnSales: React.FC = () => {
  const { t } = useLanguage();
  const [dateRange, setDateRange] = useState<DateRangeProps>(
    getCurrentMonthToTodayRange()
  );

  // Agregado en el back sobre todo el periodo elegido.
  const { summary } = useDashboardSummary("channel", dateRange);

  const totalSales = summary.totals.sales;

  const data = useMemo(() => toChartRows(summary.daily, ["sales"]), [summary]);

  return (
    <>
      <OperationArea
        title={`${t.components.operations.ownSales.title}`}
        calendar={{
          show: true,
          dateRange: dateRange,
          setDateRange: setDateRange,
        }}
        buttonFooter={{
          show: true,
          text: "Ver informes",
          type: "link",
          link: `${RouterEnum.REPORTS}?tab=${ReportsTabEnum.ReportsOwnSales}`,
        }}
      >
        <OperationItem text={formatCurrency(totalSales)} />

        <OperationStatistics
          data={data}
          lines={[
            {
              dataKey: "sales",
              color: vars.colorGreen,
              name: t.components.operations.statistics.lineSalesPerDay,
            },
          ]}
          detailedTooltip
          currencySymbol="€"
        />
      </OperationArea>
    </>
  );
};

export default OperationOwnSales;
